const { getOwnPropertyNames: ut, getOwnPropertySymbols: lt } = Object, { hasOwnProperty: ht } = Object.prototype;
function F(n, t) {
  return function(e, s, o) {
    return n(e, s, o) && t(e, s, o);
  };
}
function R(n) {
  return function(r, e, s) {
    if (!r || !e || typeof r != "object" || typeof e != "object")
      return n(r, e, s);
    const { cache: o } = s, a = o.get(r), c = o.get(e);
    if (a && c)
      return a === e && c === r;
    o.set(r, e), o.set(e, r);
    const i = n(r, e, s);
    return o.delete(r), o.delete(e), i;
  };
}
function ft(n) {
  return n?.[Symbol.toStringTag];
}
function H(n) {
  return ut(n).concat(lt(n));
}
const pt = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  Object.hasOwn || ((n, t) => ht.call(n, t))
);
function b(n, t) {
  return n === t || !n && !t && n !== n && t !== t;
}
const dt = "__v", mt = "__o", gt = "_owner", { getOwnPropertyDescriptor: Y, keys: J } = Object;
function yt(n, t) {
  return n.byteLength === t.byteLength && N(new Uint8Array(n), new Uint8Array(t));
}
function Et(n, t, r) {
  let e = n.length;
  if (t.length !== e)
    return !1;
  for (; e-- > 0; )
    if (!r.equals(n[e], t[e], e, e, n, t, r))
      return !1;
  return !0;
}
function wt(n, t) {
  return n.byteLength === t.byteLength && N(new Uint8Array(n.buffer, n.byteOffset, n.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
}
function At(n, t) {
  return b(n.getTime(), t.getTime());
}
function _t(n, t) {
  return n.name === t.name && n.message === t.message && n.cause === t.cause && n.stack === t.stack;
}
function Mt(n, t) {
  return n === t;
}
function Q(n, t, r) {
  const e = n.size;
  if (e !== t.size)
    return !1;
  if (!e)
    return !0;
  const s = new Array(e), o = n.entries();
  let a, c, i = 0;
  for (; (a = o.next()) && !a.done; ) {
    const l = t.entries();
    let h = !1, u = 0;
    for (; (c = l.next()) && !c.done; ) {
      if (s[u]) {
        u++;
        continue;
      }
      const d = a.value, g = c.value;
      if (r.equals(d[0], g[0], i, u, n, t, r) && r.equals(d[1], g[1], d[0], g[0], n, t, r)) {
        h = s[u] = !0;
        break;
      }
      u++;
    }
    if (!h)
      return !1;
    i++;
  }
  return !0;
}
const kt = b;
function xt(n, t, r) {
  const e = J(n);
  let s = e.length;
  if (J(t).length !== s)
    return !1;
  for (; s-- > 0; )
    if (!it(n, t, r, e[s]))
      return !1;
  return !0;
}
function P(n, t, r) {
  const e = H(n);
  let s = e.length;
  if (H(t).length !== s)
    return !1;
  let o, a, c;
  for (; s-- > 0; )
    if (o = e[s], !it(n, t, r, o) || (a = Y(n, o), c = Y(t, o), (a || c) && (!a || !c || a.configurable !== c.configurable || a.enumerable !== c.enumerable || a.writable !== c.writable)))
      return !1;
  return !0;
}
function Ct(n, t) {
  return b(n.valueOf(), t.valueOf());
}
function Ot(n, t) {
  return n.source === t.source && n.flags === t.flags;
}
function X(n, t, r) {
  const e = n.size;
  if (e !== t.size)
    return !1;
  if (!e)
    return !0;
  const s = new Array(e), o = n.values();
  let a, c;
  for (; (a = o.next()) && !a.done; ) {
    const i = t.values();
    let l = !1, h = 0;
    for (; (c = i.next()) && !c.done; ) {
      if (!s[h] && r.equals(a.value, c.value, a.value, c.value, n, t, r)) {
        l = s[h] = !0;
        break;
      }
      h++;
    }
    if (!l)
      return !1;
  }
  return !0;
}
function N(n, t) {
  let r = n.byteLength;
  if (t.byteLength !== r || n.byteOffset !== t.byteOffset)
    return !1;
  for (; r-- > 0; )
    if (n[r] !== t[r])
      return !1;
  return !0;
}
function Tt(n, t) {
  return n.hostname === t.hostname && n.pathname === t.pathname && n.protocol === t.protocol && n.port === t.port && n.hash === t.hash && n.username === t.username && n.password === t.password;
}
function it(n, t, r, e) {
  return (e === gt || e === mt || e === dt) && (n.$$typeof || t.$$typeof) ? !0 : pt(t, e) && r.equals(n[e], t[e], e, e, n, t, r);
}
const vt = "[object ArrayBuffer]", It = "[object Arguments]", bt = "[object Boolean]", Lt = "[object DataView]", Pt = "[object Date]", St = "[object Error]", jt = "[object Map]", Rt = "[object Number]", qt = "[object Object]", Ut = "[object RegExp]", Nt = "[object Set]", Ft = "[object String]", Zt = {
  "[object Int8Array]": !0,
  "[object Uint8Array]": !0,
  "[object Uint8ClampedArray]": !0,
  "[object Int16Array]": !0,
  "[object Uint16Array]": !0,
  "[object Int32Array]": !0,
  "[object Uint32Array]": !0,
  "[object Float16Array]": !0,
  "[object Float32Array]": !0,
  "[object Float64Array]": !0,
  "[object BigInt64Array]": !0,
  "[object BigUint64Array]": !0
}, Bt = "[object URL]", Dt = Object.prototype.toString;
function Gt({ areArrayBuffersEqual: n, areArraysEqual: t, areDataViewsEqual: r, areDatesEqual: e, areErrorsEqual: s, areFunctionsEqual: o, areMapsEqual: a, areNumbersEqual: c, areObjectsEqual: i, arePrimitiveWrappersEqual: l, areRegExpsEqual: h, areSetsEqual: u, areTypedArraysEqual: d, areUrlsEqual: g, unknownTagComparators: y }) {
  return function(f, p, m) {
    if (f === p)
      return !0;
    if (f == null || p == null)
      return !1;
    const M = typeof f;
    if (M !== typeof p)
      return !1;
    if (M !== "object")
      return M === "number" ? c(f, p, m) : M === "function" ? o(f, p, m) : !1;
    const x = f.constructor;
    if (x !== p.constructor)
      return !1;
    if (x === Object)
      return i(f, p, m);
    if (Array.isArray(f))
      return t(f, p, m);
    if (x === Date)
      return e(f, p, m);
    if (x === RegExp)
      return h(f, p, m);
    if (x === Map)
      return a(f, p, m);
    if (x === Set)
      return u(f, p, m);
    const A = Dt.call(f);
    if (A === Pt)
      return e(f, p, m);
    if (A === Ut)
      return h(f, p, m);
    if (A === jt)
      return a(f, p, m);
    if (A === Nt)
      return u(f, p, m);
    if (A === qt)
      return typeof f.then != "function" && typeof p.then != "function" && i(f, p, m);
    if (A === Bt)
      return g(f, p, m);
    if (A === St)
      return s(f, p, m);
    if (A === It)
      return i(f, p, m);
    if (Zt[A])
      return d(f, p, m);
    if (A === vt)
      return n(f, p, m);
    if (A === Lt)
      return r(f, p, m);
    if (A === bt || A === Rt || A === Ft)
      return l(f, p, m);
    if (y) {
      let L = y[A];
      if (!L) {
        const k = ft(f);
        k && (L = y[k]);
      }
      if (L)
        return L(f, p, m);
    }
    return !1;
  };
}
function $t({ circular: n, createCustomConfig: t, strict: r }) {
  let e = {
    areArrayBuffersEqual: yt,
    areArraysEqual: r ? P : Et,
    areDataViewsEqual: wt,
    areDatesEqual: At,
    areErrorsEqual: _t,
    areFunctionsEqual: Mt,
    areMapsEqual: r ? F(Q, P) : Q,
    areNumbersEqual: kt,
    areObjectsEqual: r ? P : xt,
    arePrimitiveWrappersEqual: Ct,
    areRegExpsEqual: Ot,
    areSetsEqual: r ? F(X, P) : X,
    areTypedArraysEqual: r ? F(N, P) : N,
    areUrlsEqual: Tt,
    unknownTagComparators: void 0
  };
  if (t && (e = Object.assign({}, e, t(e))), n) {
    const s = R(e.areArraysEqual), o = R(e.areMapsEqual), a = R(e.areObjectsEqual), c = R(e.areSetsEqual);
    e = Object.assign({}, e, {
      areArraysEqual: s,
      areMapsEqual: o,
      areObjectsEqual: a,
      areSetsEqual: c
    });
  }
  return e;
}
function zt(n) {
  return function(t, r, e, s, o, a, c) {
    return n(t, r, c);
  };
}
function Vt({ circular: n, comparator: t, createState: r, equals: e, strict: s }) {
  if (r)
    return function(c, i) {
      const { cache: l = n ? /* @__PURE__ */ new WeakMap() : void 0, meta: h } = r();
      return t(c, i, {
        cache: l,
        equals: e,
        meta: h,
        strict: s
      });
    };
  if (n)
    return function(c, i) {
      return t(c, i, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: e,
        meta: void 0,
        strict: s
      });
    };
  const o = {
    cache: void 0,
    equals: e,
    meta: void 0,
    strict: s
  };
  return function(c, i) {
    return t(c, i, o);
  };
}
const tt = T();
T({ strict: !0 });
T({ circular: !0 });
T({
  circular: !0,
  strict: !0
});
T({
  createInternalComparator: () => b
});
T({
  strict: !0,
  createInternalComparator: () => b
});
T({
  circular: !0,
  createInternalComparator: () => b
});
T({
  circular: !0,
  createInternalComparator: () => b,
  strict: !0
});
function T(n = {}) {
  const { circular: t = !1, createInternalComparator: r, createState: e, strict: s = !1 } = n, o = $t(n), a = Gt(o), c = r ? r(a) : zt(a);
  return Vt({ circular: t, comparator: a, createState: e, equals: c, strict: s });
}
const et = [
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
], Z = 1, S = 8, E = new Uint32Array(96);
class V {
  /**
   * Creates an index from raw `ArrayBuffer` data.
   * @param {ArrayBufferLike} data
   */
  static from(t) {
    if (!t || t.byteLength === void 0 || t.buffer)
      throw new Error("Data must be an instance of ArrayBuffer or SharedArrayBuffer.");
    const [r, e] = new Uint8Array(t, 0, 2);
    if (r !== 219)
      throw new Error("Data does not appear to be in a KDBush format.");
    const s = e >> 4;
    if (s !== Z)
      throw new Error(`Got v${s} data when expected v${Z}.`);
    const o = et[e & 15];
    if (!o)
      throw new Error("Unrecognized array type.");
    const [a] = new Uint16Array(t, 2, 1), [c] = new Uint32Array(t, 4, 1);
    return new V(c, a, o, void 0, t);
  }
  /**
   * Creates an index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBufferConstructor | SharedArrayBufferConstructor} [ArrayBufferType=ArrayBuffer] The array buffer type used for storage (`ArrayBuffer` by default).
   * @param {ArrayBufferLike} [data] (For internal use only)
   */
  constructor(t, r = 64, e = Float64Array, s = ArrayBuffer, o) {
    if (isNaN(t) || t < 0) throw new Error(`Unexpected numItems value: ${t}.`);
    this.numItems = +t, this.nodeSize = Math.min(Math.max(+r, 2), 65535), this.ArrayType = e, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
    const a = et.indexOf(this.ArrayType), c = t * 2 * this.ArrayType.BYTES_PER_ELEMENT, i = t * this.IndexArrayType.BYTES_PER_ELEMENT, l = (8 - i % 8) % 8;
    if (a < 0)
      throw new Error(`Unexpected typed array class: ${e}.`);
    if (o)
      this.data = o, this.ids = new this.IndexArrayType(o, S, t), this.coords = new e(o, S + i + l, t * 2), this._pos = t * 2, this._finished = !0;
    else {
      const h = this.data = new s(S + c + i + l);
      this.ids = new this.IndexArrayType(h, S, t), this.coords = new e(h, S + i + l, t * 2), this._pos = 0, this._finished = !1, new Uint8Array(h, 0, 2).set([219, (Z << 4) + a]), new Uint16Array(h, 2, 1)[0] = r, new Uint32Array(h, 4, 1)[0] = t;
    }
  }
  /**
   * Add a point to the index.
   * @param {number} x
   * @param {number} y
   * @returns {number} An incremental index associated with the added item (starting from `0`).
   */
  add(t, r) {
    const e = this._pos >> 1;
    return this.ids[e] = e, this.coords[this._pos++] = t, this.coords[this._pos++] = r, e;
  }
  /**
   * Perform indexing of the added points.
   */
  finish() {
    const t = this._pos >> 1;
    if (t !== this.numItems)
      throw new Error(`Added ${t} items when expected ${this.numItems}.`);
    return G(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
  }
  /**
   * Search the index for items within a given bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number[]} An array of indices correponding to the found items.
   */
  range(t, r, e, s) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    const { ids: o, coords: a, nodeSize: c } = this;
    E[0] = 0, E[1] = o.length - 1, E[2] = 0;
    let i = 3;
    const l = [];
    for (; i > 0; ) {
      const h = E[--i], u = E[--i], d = E[--i];
      if (u - d <= c) {
        for (let f = d; f <= u; f++) {
          const p = a[2 * f], m = a[2 * f + 1];
          p >= t && p <= e && m >= r && m <= s && l.push(o[f]);
        }
        continue;
      }
      const g = d + u >> 1, y = a[2 * g], w = a[2 * g + 1];
      y >= t && y <= e && w >= r && w <= s && l.push(o[g]), (h === 0 ? t <= y : r <= w) && (E[i++] = d, E[i++] = g - 1, E[i++] = 1 - h), (h === 0 ? e >= y : s >= w) && (E[i++] = g + 1, E[i++] = u, E[i++] = 1 - h);
    }
    return l;
  }
  /**
   * Search the index for items within a given radius.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @returns {number[]} An array of indices correponding to the found items.
   */
  within(t, r, e) {
    const s = (
      /** @type {number[]} */
      []
    );
    return this.withinInto(t, r, e, s), s;
  }
  /**
   * Search the index for items within a given radius, writing matching ids into `out`
   * via indexed assignment (`out[i] = id`). Accepts any indexed-writable container —
   * a typed array sized to the expected upper bound (allocation-free, fast) or a plain
   * `Array` (which will grow as needed). Returns the number of matches written.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @param {number[] | TypedArray} out Container to write matching ids into.
   * @returns {number} The number of matches written to `out`.
   */
  withinInto(t, r, e, s) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    const { ids: o, coords: a, nodeSize: c } = this;
    E[0] = 0, E[1] = o.length - 1, E[2] = 0;
    let i = 3, l = 0;
    const h = e * e;
    for (; i > 0; ) {
      const u = E[--i], d = E[--i], g = E[--i];
      if (d - g <= c) {
        for (let p = g; p <= d; p++)
          rt(a[2 * p], a[2 * p + 1], t, r) <= h && (s[l++] = o[p]);
        continue;
      }
      const y = g + d >> 1, w = a[2 * y], f = a[2 * y + 1];
      rt(w, f, t, r) <= h && (s[l++] = o[y]), (u === 0 ? t - e <= w : r - e <= f) && (E[i++] = g, E[i++] = y - 1, E[i++] = 1 - u), (u === 0 ? t + e >= w : r + e >= f) && (E[i++] = y + 1, E[i++] = d, E[i++] = 1 - u);
    }
    return l;
  }
}
function G(n, t, r, e, s, o) {
  if (s - e <= r) return;
  const a = e + s >> 1;
  ot(n, t, a, e, s, o), G(n, t, r, e, a - 1, 1 - o), G(n, t, r, a + 1, s, 1 - o);
}
function ot(n, t, r, e, s, o) {
  for (; s > e; ) {
    if (s - e > 600) {
      const l = s - e + 1, h = r - e + 1, u = Math.log(l), d = 0.5 * Math.exp(2 * u / 3), g = 0.5 * Math.sqrt(u * d * (l - d) / l) * (h - l / 2 < 0 ? -1 : 1), y = Math.max(e, Math.floor(r - h * d / l + g)), w = Math.min(s, Math.floor(r + (l - h) * d / l + g));
      ot(n, t, r, y, w, o);
    }
    const a = t[2 * r + o];
    let c = e, i = s;
    for (j(n, t, e, r), t[2 * s + o] > a && j(n, t, e, s); c < i; ) {
      for (j(n, t, c, i), c++, i--; t[2 * c + o] < a; ) c++;
      for (; t[2 * i + o] > a; ) i--;
    }
    t[2 * e + o] === a ? j(n, t, e, i) : (i++, j(n, t, i, s)), i <= r && (e = i + 1), r <= i && (s = i - 1);
  }
}
function j(n, t, r, e) {
  B(n, r, e), B(t, 2 * r, 2 * e), B(t, 2 * r + 1, 2 * e + 1);
}
function B(n, t, r) {
  const e = n[t];
  n[t] = n[r], n[r] = e;
}
function rt(n, t, r, e) {
  const s = n - r, o = t - e;
  return s * s + o * o;
}
const Kt = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: !1,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: !1,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: (n) => n
  // props => ({sum: props.my_value})
}, nt = Math.fround || /* @__PURE__ */ ((n) => ((t) => (n[0] = +t, n[0])))(new Float32Array(1)), v = 2, O = 3, D = 4, C = 5, at = 6;
class Wt {
  constructor(t) {
    this.options = Object.assign(Object.create(Kt), t), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
  }
  load(t) {
    const { log: r, minZoom: e, maxZoom: s } = this.options;
    r && console.time("total time");
    const o = `prepare ${t.length} points`;
    r && console.time(o), this.points = t;
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const l = t[i];
      if (!l.geometry) continue;
      const [h, u] = l.geometry.coordinates, d = nt(q(h)), g = nt(U(u));
      a.push(
        d,
        g,
        // projected point coordinates
        1 / 0,
        // the last zoom the point was processed at
        i,
        // index of the source feature in the original input array
        -1,
        // parent cluster id
        1
        // number of points in a cluster
      ), this.options.reduce && a.push(0);
    }
    let c = this.trees[s + 1] = this._createTree(a);
    r && console.timeEnd(o);
    for (let i = s; i >= e; i--) {
      const l = +Date.now();
      c = this.trees[i] = this._createTree(this._cluster(c, i)), r && console.log("z%d: %d clusters in %dms", i, c.numItems, +Date.now() - l);
    }
    return r && console.timeEnd("total time"), this;
  }
  getClusters(t, r) {
    let e = ((t[0] + 180) % 360 + 360) % 360 - 180;
    const s = Math.max(-90, Math.min(90, t[1]));
    let o = t[2] === 180 ? 180 : ((t[2] + 180) % 360 + 360) % 360 - 180;
    const a = Math.max(-90, Math.min(90, t[3]));
    if (t[2] - t[0] >= 360)
      e = -180, o = 180;
    else if (e > o) {
      const u = this.getClusters([e, s, 180, a], r), d = this.getClusters([-180, s, o, a], r);
      return u.concat(d);
    }
    const c = this.trees[this._limitZoom(r)], i = c.range(q(e), U(a), q(o), U(s)), l = c.data, h = [];
    for (const u of i) {
      const d = this.stride * u;
      h.push(l[d + C] > 1 ? st(l, d, this.clusterProps) : this.points[l[d + O]]);
    }
    return h;
  }
  getChildren(t) {
    const r = this._getOriginId(t), e = this._getOriginZoom(t), s = "No cluster with the specified id.", o = this.trees[e];
    if (!o) throw new Error(s);
    const a = o.data;
    if (r * this.stride >= a.length) throw new Error(s);
    const c = this.options.radius / (this.options.extent * Math.pow(2, e - 1)), i = a[r * this.stride], l = a[r * this.stride + 1], h = o.within(i, l, c), u = [];
    for (const d of h) {
      const g = d * this.stride;
      a[g + D] === t && u.push(a[g + C] > 1 ? st(a, g, this.clusterProps) : this.points[a[g + O]]);
    }
    if (u.length === 0) throw new Error(s);
    return u;
  }
  getLeaves(t, r, e) {
    r = r || 10, e = e || 0;
    const s = [];
    return this._appendLeaves(s, t, r, e, 0), s;
  }
  getTile(t, r, e) {
    const s = this.trees[this._limitZoom(t)], o = Math.pow(2, t), { extent: a, radius: c } = this.options, i = c / a, l = (e - i) / o, h = (e + 1 + i) / o, u = {
      features: []
    };
    return this._addTileFeatures(
      s.range((r - i) / o, l, (r + 1 + i) / o, h),
      s.data,
      r,
      e,
      o,
      u
    ), r === 0 && this._addTileFeatures(
      s.range(1 - i / o, l, 1, h),
      s.data,
      o,
      e,
      o,
      u
    ), r === o - 1 && this._addTileFeatures(
      s.range(0, l, i / o, h),
      s.data,
      -1,
      e,
      o,
      u
    ), u.features.length ? u : null;
  }
  getClusterExpansionZoom(t) {
    let r = this._getOriginZoom(t) - 1;
    for (; r <= this.options.maxZoom; ) {
      const e = this.getChildren(t);
      if (r++, e.length !== 1) break;
      t = e[0].properties.cluster_id;
    }
    return r;
  }
  _appendLeaves(t, r, e, s, o) {
    const a = this.getChildren(r);
    for (const c of a) {
      const i = c.properties;
      if (i && i.cluster ? o + i.point_count <= s ? o += i.point_count : o = this._appendLeaves(t, i.cluster_id, e, s, o) : o < s ? o++ : t.push(c), t.length === e) break;
    }
    return o;
  }
  _createTree(t) {
    const r = new V(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
    for (let e = 0; e < t.length; e += this.stride) r.add(t[e], t[e + 1]);
    return r.finish(), r.data = t, r;
  }
  _addTileFeatures(t, r, e, s, o, a) {
    for (const c of t) {
      const i = c * this.stride, l = r[i + C] > 1;
      let h, u, d;
      if (l)
        h = ct(r, i, this.clusterProps), u = r[i], d = r[i + 1];
      else {
        const w = this.points[r[i + O]];
        h = w.properties;
        const [f, p] = w.geometry.coordinates;
        u = q(f), d = U(p);
      }
      const g = {
        type: 1,
        geometry: [[
          Math.round(this.options.extent * (u * o - e)),
          Math.round(this.options.extent * (d * o - s))
        ]],
        tags: h
      };
      let y;
      l || this.options.generateId ? y = r[i + O] : y = this.points[r[i + O]].id, y !== void 0 && (g.id = y), a.features.push(g);
    }
  }
  _limitZoom(t) {
    return Math.max(this.options.minZoom, Math.min(Math.floor(+t), this.options.maxZoom + 1));
  }
  _cluster(t, r) {
    const { radius: e, extent: s, reduce: o, minPoints: a } = this.options, c = e / (s * Math.pow(2, r)), i = t.data, l = [], h = this.stride;
    for (let u = 0; u < i.length; u += h) {
      if (i[u + v] <= r) continue;
      i[u + v] = r;
      const d = i[u], g = i[u + 1], y = t.within(i[u], i[u + 1], c), w = i[u + C];
      let f = w;
      for (const p of y) {
        const m = p * h;
        i[m + v] > r && (f += i[m + C]);
      }
      if (f > w && f >= a) {
        let p = d * w, m = g * w, M, x = -1;
        const A = ((u / h | 0) << 5) + (r + 1) + this.points.length;
        for (const L of y) {
          const k = L * h;
          if (i[k + v] <= r) continue;
          i[k + v] = r;
          const W = i[k + C];
          p += i[k] * W, m += i[k + 1] * W, i[k + D] = A, o && (M || (M = this._map(i, u, !0), x = this.clusterProps.length, this.clusterProps.push(M)), o(M, this._map(i, k)));
        }
        i[u + D] = A, l.push(p / f, m / f, 1 / 0, A, -1, f), o && l.push(x);
      } else {
        for (let p = 0; p < h; p++) l.push(i[u + p]);
        if (f > 1)
          for (const p of y) {
            const m = p * h;
            if (!(i[m + v] <= r)) {
              i[m + v] = r;
              for (let M = 0; M < h; M++) l.push(i[m + M]);
            }
          }
      }
    }
    return l;
  }
  // get index of the point from which the cluster originated
  _getOriginId(t) {
    return t - this.points.length >> 5;
  }
  // get zoom of the point from which the cluster originated
  _getOriginZoom(t) {
    return (t - this.points.length) % 32;
  }
  _map(t, r, e) {
    if (t[r + C] > 1) {
      const a = this.clusterProps[t[r + at]];
      return e ? Object.assign({}, a) : a;
    }
    const s = this.points[t[r + O]].properties, o = this.options.map(s);
    return e && o === s ? Object.assign({}, o) : o;
  }
}
function st(n, t, r) {
  return {
    type: "Feature",
    id: n[t + O],
    properties: ct(n, t, r),
    geometry: {
      type: "Point",
      coordinates: [Ht(n[t]), Yt(n[t + 1])]
    }
  };
}
function ct(n, t, r) {
  const e = n[t + C], s = e >= 1e4 ? `${Math.round(e / 1e3)}k` : e >= 1e3 ? `${Math.round(e / 100) / 10}k` : e, o = n[t + at], a = o === -1 ? {} : Object.assign({}, r[o]);
  return Object.assign(a, {
    cluster: !0,
    cluster_id: n[t + O],
    point_count: e,
    point_count_abbreviated: s
  });
}
function q(n) {
  return n / 360 + 0.5;
}
function U(n) {
  const t = Math.sin(n * Math.PI / 180), r = 0.5 - 0.25 * Math.log((1 + t) / (1 - t)) / Math.PI;
  return r < 0 ? 0 : r > 1 ? 1 : r;
}
function Ht(n) {
  return (n - 0.5) * 360;
}
function Yt(n) {
  const t = (180 - n * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
}
function Jt(n, t) {
  var r = {};
  for (var e in n) Object.prototype.hasOwnProperty.call(n, e) && t.indexOf(e) < 0 && (r[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, e = Object.getOwnPropertySymbols(n); s < e.length; s++)
      t.indexOf(e[s]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[s]) && (r[e[s]] = n[e[s]]);
  return r;
}
class _ {
  static isAdvancedMarkerAvailable(t) {
    return google.maps.marker && t.getMapCapabilities().isAdvancedMarkersAvailable === !0;
  }
  static isAdvancedMarker(t) {
    return google.maps.marker && t instanceof google.maps.marker.AdvancedMarkerElement;
  }
  static setMap(t, r) {
    this.isAdvancedMarker(t) ? t.map = r : t.setMap(r);
  }
  static getPosition(t) {
    if (this.isAdvancedMarker(t)) {
      if (t.position) {
        if (t.position instanceof google.maps.LatLng)
          return t.position;
        if (Number.isFinite(t.position.lat) && Number.isFinite(t.position.lng))
          return new google.maps.LatLng(t.position.lat, t.position.lng);
      }
      return new google.maps.LatLng(null);
    }
    return t.getPosition();
  }
  static getVisible(t) {
    return this.isAdvancedMarker(t) ? !0 : t.getVisible();
  }
}
class $ {
  constructor({ markers: t, position: r }) {
    this.markers = [], t && (this.markers = t), r && (r instanceof google.maps.LatLng ? this._position = r : this._position = new google.maps.LatLng(r));
  }
  get bounds() {
    if (this.markers.length === 0 && !this._position)
      return;
    const t = new google.maps.LatLngBounds(this._position, this._position);
    for (const r of this.markers)
      t.extend(_.getPosition(r));
    return t;
  }
  get position() {
    return this._position || this.bounds.getCenter();
  }
  /**
   * Get the count of **visible** markers.
   */
  get count() {
    return this.markers.filter((t) => _.getVisible(t)).length;
  }
  /**
   * Add a marker to the cluster.
   */
  push(t) {
    this.markers.push(t);
  }
  /**
   * Cleanup references and remove marker from map.
   */
  delete() {
    this.marker && (_.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
  }
}
function z(n, t = "assertion failed") {
  if (n == null)
    throw Error(t);
}
class Qt {
  constructor({ maxZoom: t = 16 }) {
    this.maxZoom = t;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */
  noop({ markers: t }) {
    return Xt(t);
  }
}
const Xt = (n) => n.map((r) => new $({
  position: _.getPosition(r),
  markers: [r]
}));
class te extends Qt {
  constructor(t) {
    var { maxZoom: r, radius: e = 60 } = t, s = Jt(t, ["maxZoom", "radius"]);
    super({ maxZoom: r }), this.markers = [], this.clusters = [], this.state = { zoom: -1 }, this.superCluster = new Wt(Object.assign({ maxZoom: this.maxZoom, radius: e }, s));
  }
  calculate(t) {
    let r = !1, e = t.map.getZoom();
    z(e), e = Math.round(e);
    const s = { zoom: e };
    if (!tt(t.markers, this.markers)) {
      r = !0, this.markers = [...t.markers];
      const o = this.markers.map((a) => {
        const c = _.getPosition(a);
        return {
          type: "Feature",
          geometry: { type: "Point", coordinates: [c.lng(), c.lat()] },
          properties: { marker: a }
        };
      });
      this.superCluster.load(o);
    }
    return r || (this.state.zoom <= this.maxZoom || s.zoom <= this.maxZoom) && (r = !tt(this.state, s)), this.state = s, t.markers.length === 0 ? (this.clusters = [], { clusters: this.clusters, changed: r }) : (r && (this.clusters = this.cluster(t)), { clusters: this.clusters, changed: r });
  }
  cluster({ map: t }) {
    const r = t.getZoom();
    return z(r), this.superCluster.getClusters([-180, -90, 180, 90], Math.round(r)).map((e) => this.transformCluster(e));
  }
  transformCluster({ geometry: { coordinates: [t, r] }, properties: e }) {
    if (e.cluster)
      return new $({
        markers: this.superCluster.getLeaves(e.cluster_id, 1 / 0).map((o) => o.properties.marker),
        position: { lat: r, lng: t }
      });
    const s = e.marker;
    return new $({
      markers: [s],
      position: _.getPosition(s)
    });
  }
}
class ee {
  constructor(t, r) {
    this.markers = { sum: t.length };
    const e = r.map((o) => o.count), s = e.reduce((o, a) => o + a, 0);
    this.clusters = {
      count: r.length,
      markers: {
        mean: s / r.length,
        sum: s,
        min: Math.min(...e),
        max: Math.max(...e)
      }
    };
  }
}
class re {
  /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */
  render({ count: t, position: r }, e, s) {
    const a = `<svg fill="${t > Math.max(10, e.clusters.markers.mean) ? "#ff0000" : "#0000ff"}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${t}</text>
</svg>`, c = `Cluster of ${t} markers`, i = Number(google.maps.Marker.MAX_ZINDEX) + t;
    if (_.isAdvancedMarkerAvailable(s)) {
      const u = new DOMParser().parseFromString(a, "image/svg+xml").documentElement;
      u.setAttribute("transform", "translate(0 25)");
      const d = {
        map: s,
        position: r,
        zIndex: i,
        title: c,
        content: u
      };
      return new google.maps.marker.AdvancedMarkerElement(d);
    }
    const l = {
      position: r,
      zIndex: i,
      title: c,
      icon: {
        url: `data:image/svg+xml;base64,${btoa(a)}`,
        anchor: new google.maps.Point(25, 25)
      }
    };
    return new google.maps.Marker(l);
  }
}
function ne(n, t) {
  for (let r in t.prototype)
    n.prototype[r] = t.prototype[r];
}
class K {
  constructor() {
    ne(K, google.maps.OverlayView);
  }
}
var I;
(function(n) {
  n.CLUSTERING_BEGIN = "clusteringbegin", n.CLUSTERING_END = "clusteringend", n.CLUSTER_CLICK = "click", n.GMP_CLICK = "gmp-click";
})(I || (I = {}));
const se = (n, t, r) => {
  t.bounds && r.fitBounds(t.bounds);
};
class ie extends K {
  constructor({ map: t, markers: r = [], algorithmOptions: e = {}, algorithm: s = new te(e), renderer: o = new re(), onClusterClick: a = se }) {
    super(), this.map = null, this.idleListener = null, this.markers = [...r], this.clusters = [], this.algorithm = s, this.renderer = o, this.onClusterClick = a, t && this.setMap(t);
  }
  addMarker(t, r) {
    this.markers.includes(t) || (this.markers.push(t), r || this.render());
  }
  addMarkers(t, r) {
    t.forEach((e) => {
      this.addMarker(e, !0);
    }), r || this.render();
  }
  removeMarker(t, r) {
    const e = this.markers.indexOf(t);
    return e === -1 ? !1 : (_.setMap(t, null), this.markers.splice(e, 1), r || this.render(), !0);
  }
  removeMarkers(t, r) {
    let e = !1;
    return t.forEach((s) => {
      e = this.removeMarker(s, !0) || e;
    }), e && !r && this.render(), e;
  }
  clearMarkers(t) {
    this.markers.length = 0, t || this.render();
  }
  /**
   * Recalculates and draws all the marker clusters.
   */
  render() {
    const t = this.getMap();
    if (t instanceof google.maps.Map && t.getProjection()) {
      google.maps.event.trigger(this, I.CLUSTERING_BEGIN, this);
      const { clusters: r, changed: e } = this.algorithm.calculate({
        markers: this.markers,
        map: t,
        mapCanvasProjection: this.getProjection()
      });
      if (e || e == null) {
        const s = /* @__PURE__ */ new Set();
        for (const a of r)
          a.markers.length == 1 && s.add(a.markers[0]);
        const o = [];
        for (const a of this.clusters)
          a.marker != null && (a.markers.length == 1 ? s.has(a.marker) || _.setMap(a.marker, null) : o.push(a.marker));
        this.clusters = r, this.renderClusters(), requestAnimationFrame(() => o.forEach((a) => _.setMap(a, null)));
      }
      google.maps.event.trigger(this, I.CLUSTERING_END, this);
    }
  }
  onAdd() {
    const t = this.getMap();
    z(t), this.idleListener = t.addListener("idle", this.render.bind(this)), this.render();
  }
  onRemove() {
    this.idleListener && google.maps.event.removeListener(this.idleListener), this.reset();
  }
  reset() {
    this.markers.forEach((t) => _.setMap(t, null)), this.clusters.forEach((t) => t.delete()), this.clusters = [];
  }
  renderClusters() {
    const t = new ee(this.markers, this.clusters), r = this.getMap();
    this.clusters.forEach((e) => {
      if (e.markers.length === 1)
        e.marker = e.markers[0];
      else if (e.marker = this.renderer.render(e, t, r), e.markers.forEach((s) => _.setMap(s, null)), this.onClusterClick) {
        const s = _.isAdvancedMarker(e.marker) ? I.GMP_CLICK : I.CLUSTER_CLICK;
        e.marker.addListener(
          s,
          /* istanbul ignore next */
          (o) => {
            google.maps.event.trigger(this, I.CLUSTER_CLICK, e), this.onClusterClick(o, e, r);
          }
        );
      }
      _.setMap(e.marker, r);
    });
  }
}
export {
  ie as M
};
